var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptystate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5F5F5;}\n\t.st1{fill:#E0E0E0;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st3{display:none;}\n\t.st4{display:inline;fill:#EBEBEB;}\n\t.st5{fill:#E8505B;}\n\t.st6{fill:#003870;}\n\t.st7{fill:#0062D1;}\n\t.st8{opacity:0.5;}\n\t.st9{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.54,
    y: 143.03,
    transform: "matrix(0.8312 -0.556 0.556 0.8312 -97.7997 162.6891)",
    className: "st0",
    width: 134.99,
    height: 198.77
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "272.42,279.66 271.15,287.54 215.37,279.5 216.64,271.62  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "244.33,251.55 252.33,252.7 243.46,307.62 235.45,306.46  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M228.47,185"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.95,181.75c0.08,0.12-11.16,7.78-25.11,17.11c-13.95,9.33-25.32,16.8-25.4,16.68 c-0.08-0.12,11.16-7.78,25.11-17.11C181.5,189.09,192.87,181.63,192.95,181.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.22,171.39c0.08,0.12-18.62,12.77-41.76,28.24c-23.15,15.48-41.97,27.93-42.05,27.81 c-0.08-0.12,18.61-12.76,41.76-28.25C215.31,183.72,234.14,171.27,234.22,171.39z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.49,183.75c0.08,0.12-18.62,12.77-41.76,28.24c-23.15,15.48-41.97,27.93-42.05,27.81 c-0.08-0.12,18.61-12.76,41.76-28.25C223.58,196.09,242.41,183.63,242.49,183.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.76,196.12c0.08,0.12-18.62,12.77-41.76,28.24c-23.15,15.48-41.97,27.93-42.05,27.81 c-0.08-0.12,18.61-12.76,41.76-28.25C231.85,208.45,250.68,196,250.76,196.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.03,208.49c0.08,0.12-18.62,12.77-41.76,28.24c-23.15,15.48-41.97,27.93-42.05,27.81 c-0.08-0.12,18.61-12.76,41.76-28.25C240.12,220.82,258.95,208.37,259.03,208.49z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 537.68,
    y: 250.43,
    transform: "matrix(0.8312 -0.556 0.556 0.8312 -85.3099 386.8)",
    className: "st0",
    width: 113.37,
    height: 166.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "639.2,365.18 638.13,371.8 591.29,365.05 592.35,358.43  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "615.61,341.57 622.33,342.54 614.88,388.66 608.15,387.69  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M602.29,285.68"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M572.46,282.95c0.08,0.12-9.35,6.57-21.07,14.4c-11.72,7.84-21.28,14.09-21.36,13.97 c-0.08-0.12,9.35-6.57,21.07-14.41C562.82,289.08,572.38,282.83,572.46,282.95z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M607.11,274.25c0.08,0.12-15.61,10.76-35.05,23.76c-19.44,13-35.26,23.44-35.34,23.32 c-0.08-0.12,15.61-10.75,35.05-23.76C591.21,284.57,607.03,274.13,607.11,274.25z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M614.06,284.63c0.08,0.12-15.61,10.76-35.05,23.76c-19.44,13-35.26,23.44-35.34,23.32 c-0.08-0.12,15.61-10.75,35.05-23.76C598.16,294.96,613.98,284.52,614.06,284.63z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M621.01,295.02c0.08,0.12-15.61,10.76-35.05,23.76c-19.44,13-35.26,23.44-35.34,23.32 c-0.08-0.12,15.61-10.75,35.05-23.76C605.1,305.34,620.93,294.9,621.01,295.02z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M627.95,305.41c0.08,0.12-15.61,10.76-35.05,23.76c-19.44,13-35.26,23.44-35.34,23.32 c-0.08-0.12,15.61-10.75,35.05-23.76C612.05,315.73,627.87,305.29,627.95,305.41z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 295.8,
    y: 90.69,
    transform: "matrix(0.8818 0.4716 -0.4716 0.8818 125.1062 -146.1305)",
    className: "st0",
    width: 116.6,
    height: 171.69
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "347.42,232.37 340.9,234.6 324.34,188.83 330.86,186.59  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "357.42,199.53 359.8,206.1 314.34,221.67 311.96,215.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M401.69,160.38"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389.72,131.99c-0.08,0.15-10.51-5.27-23.29-12.11c-12.79-6.84-23.08-12.5-23-12.65 c0.08-0.15,10.51,5.27,23.29,12.11C379.51,126.18,389.8,131.84,389.72,131.99z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.4,159.23c-0.08,0.15-17.34-8.92-38.54-20.26c-21.21-11.34-38.34-20.66-38.26-20.81 c0.08-0.15,17.34,8.92,38.55,20.27C397.35,149.76,414.48,159.08,414.4,159.23z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.34,170.56c-0.08,0.15-17.34-8.92-38.54-20.26c-21.21-11.34-38.34-20.66-38.26-20.81 c0.08-0.15,17.34,8.92,38.55,20.27C391.29,161.09,408.42,170.41,408.34,170.56z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.28,181.89c-0.08,0.15-17.34-8.92-38.54-20.26c-21.21-11.34-38.34-20.66-38.26-20.81 c0.08-0.15,17.34,8.92,38.55,20.27C385.23,172.42,402.36,181.74,402.28,181.89z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.22,193.22c-0.08,0.15-17.34-8.92-38.54-20.26c-21.21-11.34-38.34-20.66-38.26-20.81 c0.08-0.15,17.34,8.92,38.55,20.27C379.17,183.75,396.3,193.07,396.22,193.22z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M150.68,164.37c-8.53,67.1,25.89,135.89,80.27,176.12s125.94,53.47,192.9,43.87 c47.8-6.85,95.21-25.59,128.9-60.18c33.69-34.59,51.45-86.56,37.88-132.9c-5.13-17.5-15.2-34.46-31.18-43.25 c-25.52-14.03-57.02-3.74-84.18,6.78c-27.16,10.52-58.61,20.88-84.19,6.96c-19.66-10.69-29.75-32.7-44.15-49.82 c-24.49-29.11-64.28-44.57-102.01-39.62c-4.72,0.62-9.38,1.55-13.96,2.78c-40.13,10.77-70.47,43.74-79.23,84.36L150.68,164.37z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lamp"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M334.49,241.27l-35.36,181.8l-4.63,23.8l236.06-1.16c10.59-0.05,19.98-9.46,23.39-23.43l41.86-171.64 c2.59-10.61-3.09-21.64-11.13-21.64l-238.92,0.25C340.48,229.26,335.87,234.18,334.49,241.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M334.49,241.27l-35.36,181.8l-4.63,23.8l236.06-1.16c10.59-0.05,19.98-9.46,23.39-23.43l41.86-171.64 c2.59-10.61-3.09-21.64-11.13-21.64l-238.92,0.25C340.48,229.26,335.87,234.18,334.49,241.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M507.92,410.76l-24.99-201.41c-1.02-8.25-7.6-14.41-15.36-14.38l-54.81,0.18c-4.06,0.01-7.95,1.74-10.83,4.8 l-26.02,27.66l-152.43,0.8c-9.31,0.05-16.47,8.86-15.24,18.77l23.21,186.15c1.03,8.24,7.59,14.39,15.34,14.37l265.65-0.52 c29.59,0.61,32.41-8.12,32.41-8.12C510.94,446.56,507.92,410.78,507.92,410.76z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "393.37,370.45 384.42,380.07 315.41,317.99 324.37,308.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "380.66,306.24 390.56,315.15 328.13,382.2 318.22,373.29  "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptystate);
export default __webpack_public_path__ + "static/media/emptystate.9295064afff57b9a80b5884c7c4dcba1.svg";
export { ForwardRef as ReactComponent };